export default "__VITE_ASSET__D8pv0z$d__"